/* ============
 * Mutations for the profile module
 * ============
 *
 * The mutations that are available on the
 * profile module.
 */
import types from './mutation-types';
// import Vue from 'vue';
import { clone } from '@/utils/object';

export default {

  // Get
  [types.FETCH_ALL_GROUPS](state) {
    state.isLoading = true;
  },
  [types.FETCH_ALL_GROUPS_SUCCESS](state, response) {
    state.isLoading = false;
    state.groups = response.groups;
    // state.groups = response.groups.map(x => { x.isEditing = false; return x;});
  },
  [types.FETCH_ALL_USER_FAIL](state, error) {
    state.isLoading = false;
    state.error = error;
  },

  // Create
  [types.CREATE_GROUP](state) {
    state.isLoading = true;
  },
  [types.CREATE_GROUP_SUCCESS](state, group) {
    state.isLoading = false;
    // state.group = group;
    // state.groups = [...state.groups];
    state.groups.unshift(group);

  },
  [types.CREATE_GROUP_FAIL](state, error) {
    state.isLoading = false;
    state.error = error;
  },

  // Edit
  [types.EDIT_START](state, id) {
    let group = state.groups.find(h => h.id === id);

    if (group.shadowCopy) {
      group.shadowCopy = null;
    }

    const shadowCopy = clone(group);

    // Vue.set(group, 'shadowCopy', shadowCopy);
    group.shadowCopy = shadowCopy;

    state.groups = [...state.groups];
  },
  [types.EDIT_CANCEL](state, id) {

    let group = state.groups.find(h => h.id === id);

    if (group.shadowCopy) {
      group.shadowCopy = null;
    }

    state.groups = [...state.groups];
  },
  [types.EDIT_SAVE_SUCCESS](state, shadowCopy) {

    const index = state.groups.findIndex(h => h.id === shadowCopy.id);
    state.groups.splice(index, 1, clone(shadowCopy));

    state.groups = [...state.groups];
  },
  [types.EDIT_FAIL](state, error) {
    state.error = error;
  },
  // GET Group Patients
  [types.FETCH_GROUP_USERS](state) {
    state.isLoading = true;
  },
  [types.FETCH_GROUP_USERS_SUCCESS](state, data) {
    state.isLoading = false;

    if (data.response && data.response.userList && data.response.skip > 0) {
      state.groupUserInfo.patientList = [...state.groupUserInfo.patientList, ...data.response.userList];
      state.groupUserInfo.hasMore = data.requestData.limit <= data.response.userList.length;
    } else {
      state.groupUserInfo = {
        totalCount: 0,
        patientList: data.response.userList,
        hasMore: data.requestData.limit <= data.response.userList.length
      };
    }

    if (state.groupUserInfo && state.groupUserInfo.patientList) {
      state.groupUserInfo.patientList.forEach(x => x.isBusy = false);
    }
  },
  [types.FETCH_GROUP_USERS_FAIL](state, error) {
    state.isLoading = false;
    state.error = error;
  },
  [types.ASSIGN_UNASSIGN_GROUP_PATIENT_BEGIN](state, data) {
    const index = state.groupUserInfo.patientList.findIndex(h => h.id === data.users[0]);
    state.groupUserInfo.patientList[index].isBusy = true;

    state.groupUserInfo = clone(state.groupUserInfo);
  },
  [types.ASSIGN_GROUP_PATIENT](state, data) {
    const index = state.groupUserInfo.patientList.findIndex(h => h.id === data.users[0]);
    state.groupUserInfo.patientList[index].group_id = data.groupId;
    state.groupUserInfo.patientList[index].isBusy = false;

    // state.groupUserInfo.patientList = [...state.groupUserInfo.patientList ];
  },
  [types.ASSIGN_GROUP_PATIENT_FAIL](state, error, data) {
    state.error = error;
    const index = state.groupUserInfo.patientList.findIndex(h => h.id === data.users[0]);
    state.groupUserInfo.patientList[index].isBusy = false;
  },
  [types.UNASSIGN_GROUP_PATIENT](state, data) {
    const index = state.groupUserInfo.patientList.findIndex(h => h.id === data.users[0]);
    state.groupUserInfo.patientList[index].group_id = null;
    state.groupUserInfo.patientList[index].isBusy = false;
  },
  [types.UNASSIGN_GROUP_PATIENT_FAIL](state, error, data) {
    state.error = error;
    const index = state.groupUserInfo.patientList.findIndex(h => h.id === data.users[0]);
    state.groupUserInfo.patientList[index].isBusy = false;
  },
  // getGroupInfo
  [types.FETCH_GROUP_INFO](state) {
    state.isLoading = true;
    state.getGroupInfo = null;
  },
  [types.FETCH_GROUP_INFO_SUCCESS](state, response) {
    state.isLoading = false;
    state.getGroupInfo = response;
  },
  [types.FETCH_GROUP_INFO_FAIL](state, error) {
    state.isLoading = false;
    state.error = error;
  },
  // CLEAR_STATE
  [types.CLEAR_STATE](state) {
    state.groups = [];
    state.group = {
      id: '',
      name: '',
      description: '',
      isEditing: false,
    };
    state.isLoading = false,
      state.groupUserInfo = {
        totalCount: 0,
        patientList: []
      };
    state.getGroupInfo = null;
  },
  //GROUP_USER_SELECT_ITEMS
  [types.GROUP_USER_SELECT_ITEMS](state, selectAll) {
    if (state.groupUserInfo && state.groupUserInfo.patientList) {
      state.groupUserInfo.patientList.forEach(x => x.isSelected = selectAll);
      state.groupUserInfo.patientList = [...state.groupUserInfo.patientList];
    }
  },
  //GROUP_USERS_SELECT_ONE_ITEM
  [types.GROUP_USERS_SELECT_ONE_ITEM](state, gp) {
    const idx = state.groupUserInfo.patientList.findIndex(x => x.id === gp.id);

    state.groupUserInfo.patientList[idx].isSelected = !state.groupUserInfo.patientList[idx].isSelected;
    state.groupUserInfo.patientList = [...state.groupUserInfo.patientList];
  },
  //GROUP_USERS_SELECT_ONE_ITEM
  [types.GROUP_USER_ASSIGN_UNASSIGN_ALL_START](state, data) {
    state.isBusy = true;
    state.groupUserInfo.patientList.forEach(x => {
      if (!x.isSelected) { return; }

      if (data.type == 'assign') {
        if (!x.group_id) {
          x.isBusy = true;
        }
      } else {
        if (x.group_id) {
          x.isBusy = true;
        }
      }
    });

    state.groupUserInfo.patientList = [...state.groupUserInfo.patientList];
  },
  [types.GROUP_USER_ASSIGN_UNASSIGN_ALL_SUCCESS](state, parm) {
    const data = parm.data;
    state.isBusy = false;
    state.groupUserInfo.patientList.forEach(x => {
      if (!x.isSelected) { return; }

      if (data.type == 'assign') {
        if (!x.group_id) {
          x.isBusy = false;
          x.group_id = data.groupId;
        }
      } else {
        if (x.group_id) {
          x.isBusy = false;
          x.group_id = null;
        }
      }
    });

    state.groupUserInfo.patientList = [...state.groupUserInfo.patientList];
  },

};
